import {DlSelectOption, enumContainer, utils} from '@wallaby-ui/core';
import {sortBy} from 'lodash';
import * as React from 'react';
import {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Options} from 'react-select';

import {
  FilterNodeTypeSelectContainer,
  FilterNodeTypeSelectOwnProps,
} from './FilterNodeTypeSelectContainer';
import {getSelectOptionIdProperty} from '../filtering_helpers';
import {useAppSelector} from 'src/js/store_hooks';

interface OwnProps extends FilterNodeTypeSelectOwnProps {
  isMui?: boolean;
}

type Props = Omit<OwnProps, 'options'>;

export const FilterNodeTypeEnumSelect: React.FC<Props> = (props) => {
  const {node, isMui, ...restProps} = props;
  const intl = useIntl();

  const enumMap = useAppSelector(
    (state) => state[enumContainer.ENUM_REDUCER_STATE_ID].enumMap
  );
  const enumName = node.getEnumName();
  const idProperty = getSelectOptionIdProperty(isMui);

  const options = useMemo<Options<DlSelectOption>>(() => {
    return sortBy(
      enumMap[enumName] &&
        enumMap[enumName].map((item) => {
          const translatedLabel = utils.TranslateUtils.translate(
            item.messageKey,
            intl
          );
          return {[idProperty]: item.name, label: translatedLabel};
        }),
      'label'
    );
  }, [enumMap, enumName, idProperty, intl]);

  return (
    <FilterNodeTypeSelectContainer
      node={node}
      {...restProps}
      valueProperty={idProperty}
      options={options}
      isMui={isMui}
    />
  );
};

FilterNodeTypeEnumSelect.displayName = 'FilterNodeTypeSelect';
